"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.fields = exports["default"] = void 0;
var _propTypes = _interopRequireDefault(require("prop-types"));
var _react = _interopRequireDefault(require("react"));
var _reduxForm = require("redux-form");
var _cccisdClickButton = _interopRequireDefault(require("cccisd-click-button"));
var _copyToClipboard = _interopRequireDefault(require("copy-to-clipboard"));
var _cccisdNotification = _interopRequireDefault(require("cccisd-notification"));
var _cccisdReduxFormHelpers = require("cccisd-redux-form-helpers");
var _style = _interopRequireDefault(require("./style.css"));
var _cccisdWysiwyg = _interopRequireDefault(require("cccisd-wysiwyg"));
var _get2 = _interopRequireDefault(require("lodash/get"));
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, _toPropertyKey(descriptor.key), descriptor); } }
function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); Object.defineProperty(Constructor, "prototype", { writable: false }); return Constructor; }
function _callSuper(t, o, e) { return o = _getPrototypeOf(o), _possibleConstructorReturn(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], _getPrototypeOf(t).constructor) : o.apply(t, e)); }
function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } else if (call !== void 0) { throw new TypeError("Derived constructors may only return object or undefined"); } return _assertThisInitialized(self); }
function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }
function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }
function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }
function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); Object.defineProperty(subClass, "prototype", { writable: false }); if (superClass) _setPrototypeOf(subClass, superClass); }
function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }
function _defineProperty(obj, key, value) { key = _toPropertyKey(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : String(i); }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); } /* eslint-disable camelcase */
var Appdefs = window.cccisd.appDefs;
var fields = exports.fields = ['firstName', 'lastName', 'fullName', 'email', 'activationUrl', 'subject', 'body', 'showEmailForm'];
var validate = function validate(values) {
  var errors = {};
  return errors;
};
var UserRegistrationForm = /*#__PURE__*/function (_React$Component) {
  _inherits(UserRegistrationForm, _React$Component);
  function UserRegistrationForm() {
    var _this;
    _classCallCheck(this, UserRegistrationForm);
    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }
    _this = _callSuper(this, UserRegistrationForm, [].concat(args));
    _defineProperty(_assertThisInitialized(_this), "copyText", function (event) {
      event.preventDefault();
      var activationUrl = _this.props.fields.activationUrl;
      (0, _copyToClipboard["default"])(activationUrl.value);
      (0, _cccisdNotification["default"])({
        message: 'Activation link copied successfully!',
        type: 'success',
        duration: 8000
      });
    });
    _defineProperty(_assertThisInitialized(_this), "renderSendEmail", function () {
      var _this$props = _this.props,
        _this$props$fields = _this$props.fields,
        body = _this$props$fields.body,
        email = _this$props$fields.email,
        fullName = _this$props$fields.fullName,
        showEmailForm = _this$props$fields.showEmailForm,
        subject = _this$props$fields.subject,
        handleSubmit = _this$props.handleSubmit,
        resending = _this$props.resending,
        submitting = _this$props.submitting,
        username = _this$props.username;
      if (!email.value) {
        return undefined;
      }
      var name = fullName.value;
      if (!name) {
        name = username;
      }
      var action = resending ? 'Resend' : 'Send';
      var highContrast = (0, _get2["default"])(Appdefs, 'app.settings.highContrast', false);
      return /*#__PURE__*/_react["default"].createElement("div", null, /*#__PURE__*/_react["default"].createElement("p", null, "You may invite this person by email here or copy the activation link."), /*#__PURE__*/_react["default"].createElement("hr", null), /*#__PURE__*/_react["default"].createElement("h3", null, "".concat(action, " Account Activation to ").concat(name)), /*#__PURE__*/_react["default"].createElement("div", {
        className: "checkbox"
      }, /*#__PURE__*/_react["default"].createElement("label", null, /*#__PURE__*/_react["default"].createElement("input", _extends({
        type: "checkbox"
      }, (0, _cccisdReduxFormHelpers.domOnlyProps)(showEmailForm))), "".concat(action, " account activation email to ").concat(email.value))), showEmailForm.value && /*#__PURE__*/_react["default"].createElement("div", null, /*#__PURE__*/_react["default"].createElement("p", {
        className: "title"
      }, "Enter your message to be sent to the user. The greeting and activation link will be included in the email."), /*#__PURE__*/_react["default"].createElement(_cccisdReduxFormHelpers.TextBlock, {
        field: subject,
        label: "Subject"
      }), /*#__PURE__*/_react["default"].createElement(_cccisdReduxFormHelpers.FieldBlock, {
        field: body
      }, /*#__PURE__*/_react["default"].createElement(_cccisdWysiwyg["default"], {
        content: body.value,
        type: "textarea",
        settings: {
          menubar: false,
          toolbar: ['bold italic underline']
        },
        onChange: body.onChange
      })), /*#__PURE__*/_react["default"].createElement("div", {
        className: _style["default"].sendInviteButtonArea
      }, /*#__PURE__*/_react["default"].createElement(_cccisdClickButton["default"], {
        className: "btn btn-success",
        style: highContrast ? {
          color: '#000'
        } : {},
        title: resending ? 'Resend Invitation' : 'Send Invitation',
        isLoading: submitting,
        onClick: handleSubmit
      }))), /*#__PURE__*/_react["default"].createElement("hr", null));
    });
    return _this;
  }
  _createClass(UserRegistrationForm, [{
    key: "render",
    value: function render() {
      var _this$props2 = this.props,
        activationUrl = _this$props2.fields.activationUrl,
        handleSubmit = _this$props2.handleSubmit;
      var renderSendEmail = this.renderSendEmail();
      var highContrast = (0, _get2["default"])(Appdefs, 'app.settings.highContrast', false);
      return /*#__PURE__*/_react["default"].createElement("form", {
        className: _style["default"].showOverflow,
        onSubmit: handleSubmit,
        id: "user_registration_form"
      }, /*#__PURE__*/_react["default"].createElement("div", null, renderSendEmail, /*#__PURE__*/_react["default"].createElement("h3", null, "Copy Account Activation Link"), /*#__PURE__*/_react["default"].createElement("p", null, "Copy the link below to paste it in another email."), /*#__PURE__*/_react["default"].createElement("div", null, /*#__PURE__*/_react["default"].createElement("p", {
        className: _style["default"].regLink
      }, activationUrl.value), /*#__PURE__*/_react["default"].createElement("div", null, /*#__PURE__*/_react["default"].createElement("button", {
        type: "button",
        style: highContrast ? {
          color: '#000'
        } : {},
        onClick: this.copyText,
        className: "btn btn-warning btn-xs"
      }, /*#__PURE__*/_react["default"].createElement("span", null, "Copy Link"))))));
    }
  }]);
  return UserRegistrationForm;
}(_react["default"].Component);
_defineProperty(UserRegistrationForm, "propTypes", {
  fields: _propTypes["default"].object.isRequired,
  handleSubmit: _propTypes["default"].func.isRequired,
  submitting: _propTypes["default"].bool.isRequired,
  dispatch: _propTypes["default"].func,
  resending: _propTypes["default"].bool,
  username: _propTypes["default"].string
});
var _default = exports["default"] = (0, _reduxForm.reduxForm)({
  form: 'user_registration_form',
  fields: fields,
  validate: validate
})(UserRegistrationForm);